import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'Videos';

const VideosApi: any = baseApi(endpoint);

export default VideosApi;